import styled from 'styled-components/macro'

import { Layout } from '@loadsmart/loadsmart-ui'

export const RadioButtonGroup = styled(Layout.Group)`
  flex-wrap: unset;
  text-align: left;
`
